import * as React from 'react';
import * as _ from 'lodash';
import * as configColumnDefs from './config';
import * as globalStyles from 'styles/style.scss';
import * as styles from './styles.scss';
import { DatePicker, Fallback, SheetData } from 'components/common';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { IState } from 'redux/global-reducers';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import {
  onSubmmitConfirmDebt,
  queryEquityConfirmDebt,
  queryEquityConfirmDebtHistory,
} from './action';
import { queryClientDetail } from 'redux/global-actions';
import { withErrorBoundary } from 'react-error-boundary';
import configEnv from 'config';

interface IConfirmDebtProps
  extends React.ClassAttributes<ConfirmDebtComponent>,
    WithNamespaces,
    RouteComponentProps {
  readonly selectedAccount: IState['selectedAccount'];
  readonly accountList: IState['accountList'];
  readonly clientDetail: IState['clientDetail'];
  readonly equityConfirmDebt: IState['equityConfirmDebt'];
  readonly equityConfirmDebtHistory: IState['equityConfirmDebtHistory'];
  readonly equitySubmitConfirmDebt: IState['equitySubmitConfirmDebt'];

  readonly queryClientDetail: typeof queryClientDetail;
  readonly queryEquityConfirmDebt: typeof queryEquityConfirmDebt;
  readonly queryEquityConfirmDebtHistory: typeof queryEquityConfirmDebtHistory;
  readonly onSubmmitConfirmDebt: typeof onSubmmitConfirmDebt;
}

interface IConfirmDebtState {
  readonly fromDate: Date;
}

class ConfirmDebtComponent extends React.Component<
  IConfirmDebtProps,
  IConfirmDebtState
> {
  private localGridApi?: GridApi;

  constructor(props: IConfirmDebtProps) {
    super(props);
    this.state = {
      fromDate: new Date(),
    };
  }

  componentDidMount() {
    if (!this.props.clientDetail?.customerProfile) {
      this.props.queryClientDetail({
        clientID: this.props.selectedAccount?.username,
      });
    }
    this.queryConfirmDebt();
    this.queryConfirmDebtHistory();
    this.props.i18n.on('languageChanged', this.onChangeLang);
  }

  componentDidUpdate(prevProps: IConfirmDebtProps) {
    if (
      this.props.equitySubmitConfirmDebt !==
        prevProps.equitySubmitConfirmDebt &&
      this.props.equitySubmitConfirmDebt.status.isSucceeded
    ) {
      this.queryConfirmDebt();
    }
    if (
      (this.props.equitySubmitConfirmDebt !==
        prevProps.equitySubmitConfirmDebt &&
        this.props.equitySubmitConfirmDebt.status.isSucceeded) ||
      this.props.selectedAccount !== prevProps.selectedAccount
    ) {
      this.queryConfirmDebt();
      this.queryConfirmDebtHistory();
    }
  }

  componentWillUnmount() {
    this.props.i18n.off('languageChanged', this.onChangeLang);
  }

  render() {
    const { t, equityConfirmDebt, equityConfirmDebtHistory } = this.props;
    const debtMarginInformationData = equityConfirmDebt?.status?.isLoading ? (
      <div className={styles.Loading}>
        <span>{t('Loading Data')}</span>
      </div>
    ) : (
      <>
        <SheetData
          rowData={
            _.isEmpty(equityConfirmDebt?.data?.resConfirmDebt) ||
            equityConfirmDebt?.data?.resConfirmDebt == null
              ? []
              : equityConfirmDebt?.data?.resConfirmDebt
          }
          columnDefs={configColumnDefs.debtMarginInfor()}
          status={equityConfirmDebt?.status}
          onGridReady={this.onGridReady}
        />
      </>
    );
    const debtConfirmationHistory = (
      <>
        <div className={styles.ConfirmDebtFilter}>
          <div className={styles.ConfirmDebtDate}>
            <p>{t('Years')}</p>
            <DatePicker
              selected={this.state.fromDate}
              onChange={this.onChangeFromDate}
              dateFormat="yyyy"
              maxDate={new Date()}
              showYearPicker
              popperModifiers={{
                flip: {
                  behavior: ['bottom'],
                  flipVariations: true,
                },
                preventOverflow: {
                  enabled: false,
                },
              }}
            />
          </div>
        </div>

        <div className={styles.ConfirmDebtContent}>
          <SheetData
            rowData={
              _.isEmpty(equityConfirmDebtHistory?.data?.resConfirmDebt) ||
              equityConfirmDebtHistory?.data?.resConfirmDebt == null
                ? []
                : equityConfirmDebtHistory?.data?.resConfirmDebt
            }
            columnDefs={configColumnDefs.debtConfirmationHistory()}
            status={equityConfirmDebtHistory?.status}
            onGridReady={this.onGridReady}
          />
        </div>
      </>
    );

    const RenderItem = (
      <div className={styles.ConfirmDebt}>
        <div className={styles.ConfirmDebtForm}>
          <p className={styles.ConfirmDebtTitle}>{t('Loan information')}</p>
          <p>{t('NOTE_CONFIRMDEBT')}</p>
          <div className={styles.ConfirmDebtData}>
            <div className={styles.DebtMarginContainer}>
              {debtMarginInformationData}
            </div>
          </div>
          <p className={styles.ConfirmDebtTitleCenter}>
            {t('NOTE_CONFIRMDEBT 2')}
            <button
              className={globalStyles.QueryButton}
              onClick={this.onClickConfirm}
              disabled={
                _.isEmpty(equityConfirmDebt?.data?.resConfirmDebt) ||
                equityConfirmDebt?.data?.resConfirmDebt[0].status
              }
            >
              {t('Confirm')}
            </button>
          </p>
        </div>
        <hr />
        <div className={styles.ConfirmDebtForm}>
          <div className={styles.DebtConfirmationHistoryContainer}>
            <p className={styles.ConfirmDebtTitle}>
              {t('Debt Confirmation History')}
            </p>
            {debtConfirmationHistory}
          </div>
        </div>
      </div>
    );
    return RenderItem;
  }

  private queryConfirmDebt = () => {
    if (this.props.selectedAccount?.account) {
      this.props.queryEquityConfirmDebt({
        accountNumber: this.props.selectedAccount?.account,
        historyBy: this.state.fromDate.getMonth(),
        signed: false,
      });
    }
  };

  private queryConfirmDebtHistory = () => {
    if (this.props.selectedAccount?.account) {
      this.props.queryEquityConfirmDebtHistory({
        accountNumber: this.props.selectedAccount?.account,
        historyBy: this.state.fromDate.getMonth(),
        historyYearBy: this.state.fromDate.getFullYear(),
        signed: true,
      });
    }
  };

  private onClickConfirm = () => {
    const {
      equityConfirmDebt: { data },
    } = this.props;
    if (data?.resConfirmDebt) {
      this.props.onSubmmitConfirmDebt(
        configEnv.loanQueryAll
          ? {
              accountNumber: data.resConfirmDebt[0].accountNumber,
              loanList: data.resConfirmDebt.map((val: any) => ({
                accountNumber: val.accountNumber,
                endingBalance: val.endingBalance,
                outstandingInterest: val.outstandingInterest,
                status: val.status,
                dateConfirm: val.dateConfirm,
                signable: val.signable,
                applicationID: val.applicationID,
                applicationDate: val.applicationDateFull,
                additionalDisbursement: val.additionalDisbursement,
                repaymentAmount: val.repaymentAmount,
              })),
            }
          : {
              accountNumber: data.resConfirmDebt.accountNumber,
              endingBalance: data.resConfirmDebt.endingBalance,
              outstandingInterest: data.resConfirmDebt.outstandingInterest,
              status: data.resConfirmDebt.status,
              dateConfirm: data.resConfirmDebt.dateConfirm,
              signable: data.resConfirmDebt.signable,
              applicationID: data.resConfirmDebt.applicationID,
              applicationDate: data.resConfirmDebt.applicationDate,
            }
      );
    }
  };

  private onChangeFromDate = (date: Date) => {
    this.setState({ fromDate: date }, () => {
      this.queryConfirmDebtHistory();
    });
  };

  private onGridReady = (event: GridReadyEvent) => {
    this.localGridApi = event.api;
  };

  private onChangeLang = () => {
    setTimeout(() => {
      this.localGridApi?.sizeColumnsToFit();
    });
  };
}

const mapStateToProps = (state: IState) => ({
  selectedAccount: state.selectedAccount,
  accountList: state.accountList,
  clientDetail: state.clientDetail,
  equityConfirmDebt: state.equityConfirmDebt,
  equitySubmitConfirmDebt: state.equitySubmitConfirmDebt,
  equityConfirmDebtHistory: state.equityConfirmDebtHistory,
});

const mapDispatchToProps = {
  queryClientDetail,
  queryEquityConfirmDebt,
  onSubmmitConfirmDebt,
  queryEquityConfirmDebtHistory,
};

const ConfirmDebt = withRouter(
  withErrorBoundary(
    withNamespaces('common')(
      connect(mapStateToProps, mapDispatchToProps)(ConfirmDebtComponent)
    ),
    Fallback,
    handleError
  )
);

export default ConfirmDebt;



// WEBPACK FOOTER //
// ./src/components/areas/Account/LoadDetail/ConfirmDebt/index.tsx